export const OnScrollEndDirective = angular
    .module('app.directives.onScrollEnd', [])
    .directive('onScrollEnd', () => {
        return {
            restrict: 'A',
            link: (scope, elem, attrs) => {
                let element = angular.element(attrs.scrollElement || elem);
                let raw = element[0];
                element.bind('scroll', () => {
                    if (raw.scrollTop + raw.offsetHeight + 5 >= raw.scrollHeight) {
                        scope.loading = true;
                        scope.$apply(attrs.onScrollEnd);
                    }
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/onScrollEnd.directive.js